export default __webpack_public_path__ + "job_templates_logo.29679687.png";